import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator';
import { Keys } from './types';
import { profile } from '../../../../model/profile';
import { push } from 'connected-react-router';

export interface IActions {
  loginRequest: () => void,
  loginSuccess: (profile: profile) => void,
  loginError: (error: any) => void,
  logout: () => void
  navigateTo: (path: string) => void;
}


export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
  return {
    navigateTo: path => dispatch(push(path)),
    loginRequest: () => {
      dispatch({
        type: Keys.LOGIN_REQUEST
      })
    },
    loginSuccess: (profile) => {
      dispatch({
        type: Keys.LOGIN_SUCCESS,
        payload: { profile }
      })
    },
    loginError: (error) => {
      dispatch({
        type: Keys.LOGIN_ERROR,
        error
      })
    },
    logout: () => {
      dispatch({
        type: Keys.LOGOUT
      })
    }
  }
}